module.exports = __webpack_public_path__ + "assets/img/logo.png?74a89367edafc18a39975a12d58adee0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 1133
// module chunks = 0